// ©2024 Austin App House. All rights reserved.
import React, { useEffect, useState } from 'react';
import { Field } from 'redux-form';
import ReactSelectField from '../../customFields/ReactSelectField';
import getFundingSourcesList from '../../../../../utils/api/get/getFundingSourcesList';

const FundingSourcesSection = (props) => {
  const [isLoading, setIsLoading] = useState(true);
  const [fundingSources, setFundingSources] = useState([]);

  const fetchData = async () => {
    setIsLoading(true);
    const newFundingSourcesList = await getFundingSourcesList();
    setFundingSources(newFundingSourcesList);
    setIsLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div className="field_col">
      <label className="field_name" htmlFor="funding-source-select">
        Use Existing Bank Info
      </label>
      <Field
        id="funding-source-select"
        name="fundingSource"
        component={ReactSelectField}
        className="flex-column"
        placeholder="Funding Source"
        options={fundingSources}
        customSelectStyleType="dashboard"
        isLoading={isLoading}
        isClearable
        required={props.isRequired ?? true}
      />
    </div>
  );
};

export default FundingSourcesSection;
